import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { WA_WINDOW } from '@ng-web-apis/common';

import { IS_DESKTOP } from '@core/tokens/tokens';

import { NamedLogoComponent } from '../named-logo/named-logo.component';
import { ContactsComponent } from '../contacts/contacts.component';
import { AgreementsLinksComponent } from '../agreements-links/agreements-links.component';

@Component({
  selector: 'mdcr-footer',
  imports: [NamedLogoComponent, ContactsComponent, AgreementsLinksComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public readonly isDesktop = inject(IS_DESKTOP);

  private readonly window = inject(WA_WINDOW);

  public scrollToTheTop(): void {
    this.window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
